import React from "react";
import SectionWrapper from "../ui/SectionWrapper";

const AboutUs: React.FC = () => {
  return (
    <>
      {/* ================= HERO ================= */}
      <SectionWrapper>
        <div className="mb-[100px] overflow-hidden rounded-b-lg bg-[#F2F4F7]">
          <div className="space-y-4 px-8 py-8 text-[15px] text-gray-800">


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Definitions</h3>
    <ul className="mt-2 space-y-1">
      <li>1.1 The "Quotation" means either a written quotation or proposal of charges which is submitted to the Customer for acceptance.</li>
      <li>1.2 The "Supplier" means Consumer Cloud Services Ltd.</li>
      <li>1.3 The "Customer" means the person, firm or company to whom the Quotation is addressed.</li>
      <li>1.4 The "Contract" means the Quotation together with these terms and conditions.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Application of Conditions</h3>
    <ul className="mt-2 space-y-2">
      <li>2.1 Any agreement made between the Supplier and Customer for the supply of goods and services by the Supplier to the Customer shall only be subject to these Terms and Conditions according to their provisions. Any representation or warranty made by or on behalf of the Customer prior to the Contract whether orally or in writing is hereby expressly excluded and shall be of no effect.</li>
      <li>2.2 Unless otherwise agreed in writing signed by the Supplier, these conditions shall override any Terms and Conditions stipulated, incorporated or referred to by the Customer in its order or another document or during pre-contract negotiations. In the event of the Supplier entering into the Contract without having submitted a written Quotation but in circumstances when the buyer has had prior notice of these Conditions, then all material and service supplied shall be subject to these Conditions.</li>
      <li>2.3 The Supplier reserves the right to assign, sub-contract or sub-let the fulfillment of the Contract or any part thereof. The Customer shall not be entitled to assign the benefit or burden of the Contract without the consent in writing of the Supplier.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Delivery and Time</h3>
    <ul className="mt-2 space-y-2">
      <li>3.1 Whilst the Supplier shall make every reasonable effort to complete the Contract within the quoted time, time shall not be the essence of the Contract unless specifically agreed by the Supplier in writing.</li>
      <li>3.2 In the event of the Customer requesting expedited completion of the Contract the Supplier shall use its best endeavours to complete in accordance with the request but shall be entitled to charge the Customer for additional costs incurred or necessitated by the request.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Charges and Payments</h3>
    <ul className="mt-2 space-y-2">
      <li>
        4.1 Unless otherwise agreed in writing by the Supplier:
        <ul className="mt-2 space-y-1 pl-6 list-disc">
          <li>4.1.1 in the United Kingdom any price shown in the Quotation is the net price exclusive of Value Added Tax.</li>
          <li>4.1.2 full payment of all invoices must be made within thirty days of the invoice unless otherwise agreed in writing by the Supplier. Without prejudice to its owner rights, the Supplier shall be entitled to charge interest on late payments at 4% per annum over Lloyds TSB PLC's base lending rate.</li>
        </ul>
      </li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Confidentiality</h3>
    <p className="mt-1">The use of data supplied by the Company is subject to following restrictions:</p>
    <ul className="mt-2 space-y-2">
      <li>5.1 Any information as to the business methods or operations acquired by either party and their employees shall be treated as confidential and shall not be divulged by any of them to any third party save where an agreement is entered into between both parties to divulge any such information in the furtherance of the contract or for any other reason mutually agreed. The obligations of confidentiality contained in this clause shall survive the expiry or termination of this Contract.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Limitation of Liability</h3>
    <ul className="mt-2 space-y-2">
      <li>6.1 In view of the difficulty in assessing the value to the Customer of the data supplied and the exclusions of liability under the contract, the Supplier advises the Customer to maintain adequate insurance against all insurable risks in respect of the data for its full value.</li>
      <li>6.2 Neither party excludes or limits liability to the other party for death or personal injury or any breach of any obligations implied by Section 12 of the Sale of Goods Act 1979 or Section 2 of the Supply of Goods and Services Act 1982.</li>
      <li>6.3 Without prejudice to the generality of Clause 12.2, in no event shall either party be liable to the other for: 12.3.1 loss of profits, business, revenue, goodwill or anticipated savings and/or 12.3.2 indirect or consequential loss or damage.</li>
      <li>6.4 The Supplier shall not be liable to the Customer or any other person under or in connection with the Contract or performance or non-performance of the services under the Contract, except to the extent that the loss or damage suffered by the Customer results solely from the negligence of the company or its agents or sub-contractors, in which case such liability shall be subject to the exclusions and limitations expressed in these Terms and Conditions. The Customer agrees to indemnify the Supplier against all claims, demands, costs and expenses in excess of the liability expressly accepted by the Supplier hereunder.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">Force Majeure</h3>
    <ul className="mt-2 space-y-2">
      <li>7.1 Notwithstanding the provisions of clause 3 the Supplier will not be liable for any loss suffered or incurred by the Customer as a result of the Supplier being unable to perform the Contract by reason of any act of God, war, lockout,strike, fire, flood, delay in transit, postal delay, riot or any other unexpected or exceptional cause, or circumstances beyond the Supplier's control, in which case the Supplier will be entitled to cancel the Contract or delay the performance for as long as reasonably necessary.</li>
    </ul>
  </div>


  <div>
    <h3 className="text-lg font-semibold text-[#0B2545]">General</h3>
    <ul className="mt-2 space-y-2">
      <li>8.1 If at any time any one or more of the provisions of these Conditions become invalid, illegal or unenforceable under any law or is held by a Court to be invalid, illegal or unenforceable the validity and enforceability of the remaining provisions hereof shall not in any way be affected or impaired by.</li>
      <li>8.2 This contract is governed by and shall be construed and operated in accordance with English Law and the Customer hereby submits to the jurisdiction of the English courts.</li>
      <li>8.3 The headings of the terms and conditions are for convenience of reference only and will not affect the meaning of anything contained herein.</li>
    </ul>
  </div>

            </div>

        </div>
      </SectionWrapper>
    </>
  );
};

export default AboutUs;
